/** Production stub — no cert routes linked in bundle. */
export const certRouteElements = null;
